// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2635900e","455":"0b97b924","977":"adf8edf8"}[chunkId] + ".chunk.js";
};